export const PROPS_CUSTOM_SELECT = {
    width: {
        container: "190px",
        containerSelect: "100%"
    },
    minWidth: "190px"
};
export const PROPS_CUSTOM_BUTTON = {
    width: "95px",
    size: "small"
};